module.exports = __webpack_public_path__ + "img/mobile_app_banner_en.89b214b4.png";